"use client";

/**
 * Atmospheric background without motion/framer — keeps the motion chunk off the
 * critical path and avoids forced-reflow mouse springs on first paint.
 */
export default function SiteBackground() {
  return (
    <div
      className="site-background pointer-events-none fixed inset-0 z-0 overflow-hidden contain-paint"
      aria-hidden
    >
      <div className="absolute inset-0 bg-[#050505]" />

      <div className="absolute left-1/2 top-1/2 h-[min(55vw,520px)] w-[min(55vw,520px)] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(13,168,159,0.09)_0%,transparent_68%)] blur-3xl" />
      <div className="absolute -left-[15%] -top-[20%] h-[min(85vw,720px)] w-[min(85vw,720px)] rounded-full bg-[radial-gradient(circle,rgba(13,168,159,0.14)_0%,rgba(19,97,110,0.08)_35%,transparent_68%)] blur-3xl" />
      <div className="absolute -bottom-[25%] -right-[15%] h-[min(70vw,560px)] w-[min(70vw,560px)] rounded-full bg-[radial-gradient(circle,rgba(13,168,159,0.1)_0%,transparent_65%)] blur-3xl" />
      <div className="absolute left-[35%] top-[40%] h-[min(40vw,360px)] w-[min(40vw,360px)] rounded-full bg-[radial-gradient(circle,rgba(13,168,159,0.05)_0%,transparent_70%)] blur-3xl" />

      <svg
        className="absolute bottom-0 right-0 h-[min(42vh,380px)] w-[min(50vw,480px)] text-accent opacity-[0.14]"
        viewBox="0 0 400 400"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMaxYMax meet"
      >
        <g stroke="currentColor" strokeWidth="0.75">
          <line x1="320" y1="80" x2="280" y2="140" />
          <line x1="280" y1="140" x2="220" y2="120" />
          <line x1="220" y1="120" x2="180" y2="200" />
          <line x1="180" y1="200" x2="120" y2="240" />
          <line x1="120" y1="240" x2="200" y2="280" />
          <line x1="200" y1="280" x2="280" y2="260" />
          <line x1="280" y1="260" x2="340" y2="320" />
          <line x1="340" y1="320" x2="380" y2="260" />
          <line x1="380" y1="260" x2="320" y2="80" />
          <line x1="280" y1="140" x2="340" y2="200" />
          <line x1="340" y1="200" x2="380" y2="260" />
          <line x1="220" y1="120" x2="300" y2="180" />
          <line x1="300" y1="180" x2="280" y2="260" />
          <line x1="180" y1="200" x2="260" y2="220" />
          <line x1="260" y1="220" x2="340" y2="200" />
          <line x1="200" y1="280" x2="260" y2="340" />
          <line x1="260" y1="340" x2="340" y2="320" />
          <line x1="120" y1="240" x2="80" y2="300" />
          <line x1="80" y1="300" x2="160" y2="360" />
          <line x1="160" y1="360" x2="260" y2="340" />
        </g>
        <g fill="currentColor">
          <circle cx="320" cy="80" r="2.5" />
          <circle cx="280" cy="140" r="2" />
          <circle cx="220" cy="120" r="2" />
          <circle cx="180" cy="200" r="2.5" />
          <circle cx="120" cy="240" r="2" />
          <circle cx="200" cy="280" r="2" />
          <circle cx="280" cy="260" r="2.5" />
          <circle cx="340" cy="320" r="2" />
          <circle cx="380" cy="260" r="2" />
          <circle cx="340" cy="200" r="2" />
          <circle cx="300" cy="180" r="1.5" />
          <circle cx="260" cy="220" r="1.5" />
          <circle cx="260" cy="340" r="2" />
          <circle cx="80" cy="300" r="1.5" />
          <circle cx="160" cy="360" r="2" />
        </g>
      </svg>
    </div>
  );
}
